export const ENGLISH_NICKNAME_FORBIDDEN_REGEX = /[^a-zA-Z0-9\[\]_]/
export const ENGLISH_COPYLEADER_FORBIDDEN_REGEX = /[^a-zA-Z0-9\[\]_]/
export const LOCAL_NICKNAME_FORBIDDEN_REGEX = /[^ㄱ-ㅎ가-힣a-zA-Z0-9\[\]_]/
export const SPECIAL_CHAR_REGEX = /[`~!@#$%^&*()_|+\-=?;:'"<>\{\}\[\]\\\/ ]/gim
